import { createFileRoute } from '@tanstack/react-router'
import { ShippingQuoteAttemptDetailPage } from '@/pages/shipping-quote-attempt-detail'

export const Route = createFileRoute(
  '/_authenticated/shipping-calculator/quote-attempts/$attemptId',
)({
  staticData: { title: 'Quote Attempt' },
  component: ShippingQuoteAttemptDetailRoute,
})

function ShippingQuoteAttemptDetailRoute() {
  const { attemptId } = Route.useParams()
  return <ShippingQuoteAttemptDetailPage attemptId={Number(attemptId)} />
}
